module.exports = __webpack_public_path__ + "img/instagram.29a8a351.png";